<!--
 * @Author: your name
 * @Date: 2020-12-29 23:08:05
 * @LastEditTime: 2021-02-05 22:17:29
 * @LastEditors: Please set LastEditors
 * @Description: In User Settings Edit
 * @FilePath: \lwdgis-ui-master\src\App.vue
-->
<template>
  <div id="app">
    <router-view/>
  </div>
</template>

<script>
export default {
  name: 'App',
  created(){
    
    
    // 在页面加载时读取sessionStorage
    if (sessionStorage.getItem('store')) {
      this.$store.replaceState(Object.assign({}, this.$store.state, JSON.parse(sessionStorage.getItem('store'))))
    } 

    // 在页面刷新时将store保存到sessionStorage里
    window.addEventListener('beforeunload', () => {
      sessionStorage.setItem('store', JSON.stringify(this.$store.state))
    })

  }

}
</script>
<style>
#app {
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  margin-top: 0px;
}
.el-main {
  margin: 0;
  padding-top: 5px;
  padding-bottom: 5px;
  padding-left: 0;
  padding-right: 0px;
}
.el-header {
  padding: 0;
  margin: 0;
}
.el-table td, .el-table th{
  padding: 6px 0px;
}
</style>



// WEBPACK FOOTER //
// src/App.vue